import { icons } from "constants/icons";
import { memo } from "react";

import { RegionInfoItems } from "./RegionInfoItems";

type Props = {
  patientRegionRightKneeDetailsProcessed: any;
  patientRegionLeftKneeDetailsProcessed: any;
  // videoExamsQuantity: [];
};
export const RegionBlockSingleKnee = memo(
  ({
    // lastExam,
    patientRegionRightKneeDetailsProcessed,
    patientRegionLeftKneeDetailsProcessed,
  }: // score,
  // videoExamsQuantity,
  // week,
  Props) => {
    return (
      <>
        <div className="flex justify-between">
          <div className="flex space-x-2 items-center">
            <img src={icons.status} alt="status" />
            <div className="flex flex-col">
              <h4 className="text-grayDark leading-4">Exam types</h4>
              <p className="flex items-baseline space-x-1  text-grayDark">
                <strong className="text-[24px] text-black leading-6 w-max">
                  Single Knee Drop Jump
                </strong>
              </p>
            </div>
          </div>

          <RegionInfoItems
            // classNames="mt-7"
            lastExamDate={
              patientRegionLeftKneeDetailsProcessed?.lastExam
                ? patientRegionLeftKneeDetailsProcessed?.lastExam[
                    patientRegionLeftKneeDetailsProcessed?.lastExam?.length - 1
                  ]
                : new Date().toISOString()
            }
            videoExamsQuantity={
              patientRegionLeftKneeDetailsProcessed?.examsCount || 0
            }
            title={"Left Knee Last Exam"}
          />
          <RegionInfoItems
            // classNames="mt-7"
            lastExamDate={
              patientRegionRightKneeDetailsProcessed?.lastExam
                ? patientRegionRightKneeDetailsProcessed?.lastExam[
                    patientRegionRightKneeDetailsProcessed?.lastExam?.length - 1
                  ]
                : new Date().toISOString()
            }
            videoExamsQuantity={
              patientRegionRightKneeDetailsProcessed?.examsCount || 0
            }
            title={"Right Knee Last Exam"}
          />
        </div>
        {/* <div>Graph</div> */}
      </>
    );
  }
);
